module.exports = __webpack_public_path__ + "img/ki.8b53d9e6.png";